<template>
    <div id="Home">
        <h1>HOME</h1>
        <router-link to="/power-scan">PowerScan</router-link>
    </div>
</template>

<script>
  export default {
    name: 'Home'
  }
</script>
